import { create } from 'zustand';
import { AVATAR_COLORS, initialsOf } from '../utils/avatar';

/* Local roster kept by the prototype-era grant flow on the Room Parents page.
   Every list of real people (Parents, Compose Email, Fundraising, both
   dashboards) comes from the API instead, so this starts empty — it only ever
   holds what was typed into that form this session. */
const useParentsStore = create((set, get) => ({
  parents: [],

  parentById: (id) => get().parents.find((p) => p.id === id) || null,

  addParent: ({ name, kid, email, phone, isRoomParent }) => {
    const parents = get().parents;
    const parent = {
      id: 'p' + parents.length + '_' + Math.floor(Math.random() * 10000),
      name,
      phone,
      email,
      onSprout: false,
      initials: initialsOf(name),
      color: AVATAR_COLORS[parents.length % AVATAR_COLORS.length],
      kids: kid ? [kid] : [],
      isRoomParent,
    };
    set({ parents: [...parents, parent] });
    return parent;
  },

  setParentEmail: (id, email) =>
    set({ parents: get().parents.map((p) => (p.id === id ? { ...p, email } : p)) }),

  setParentPhone: (id, phone) =>
    set({ parents: get().parents.map((p) => (p.id === id ? { ...p, phone } : p)) }),

  setIsRoomParent: (id, isRoomParent) =>
    set({ parents: get().parents.map((p) => (p.id === id ? { ...p, isRoomParent } : p)) }),

  setIsRoomParentByName: (name, isRoomParent) =>
    set({ parents: get().parents.map((p) => (p.name === name ? { ...p, isRoomParent } : p)) }),
}));

export default useParentsStore;
